module.exports = __webpack_public_path__ + "src/assets/svgs/landingV2/guest/hiw-title-bg.svg";